import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import type { DeleteEducationalInformationFields } from '../types/SharedActions';

import { updateLocalStorage } from './updateLocalStorage';

export const deleteEducationalExperienceFields = (
  doc: CoverLetterDocumentType,
  value: DeleteEducationalInformationFields['value']
): void => {
  const educationExperiences = [...(doc.educationExperience ?? [])].filter(
    (_, index) => index !== value
  );

  updateLocalStorage(`educationExperience`, educationExperiences);
};
